import { useMediaQuery } from '@mui/material'

const hoverCapableQuery = '(hover: hover) and (pointer: fine)'

/** Scopes a hover style to devices that can hover: a touch browser keeps `:hover` on an element after a tap. */
export const hoverCapableMediaQuery = `@media ${hoverCapableQuery}`

/**
 * True when the primary input device can hover (mouse, trackpad), false for touch-only
 * devices. Unlike {@link useUiContext}, which is a viewport-width breakpoint, this reflects
 * actual input capability, so a wide touch device and a narrow mouse-driven window are each
 * classified correctly.
 */
export function useHasHoverCapability(): boolean {
  return useMediaQuery(hoverCapableQuery)
}
